import { render, staticRenderFns } from "./CreateCoursePage.vue?vue&type=template&id=1f71c922&scoped=true&"
import script from "./CreateCoursePage.vue?vue&type=script&lang=js&"
export * from "./CreateCoursePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f71c922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
